module.exports = __webpack_public_path__ + "img/desc.36053a26.png";